<template>
  <div id="userLayout" :class="['user-layout-wrapper', device]">
    <div class="container">
      <div class="top">
        <div class="header">
          <a href="/">
            <img :src="logo" class="logo" alt="logo">
            <span class="title">{{title}}</span>
          </a>
        </div>
        <div class="desc">
          <p>{{describe}}</p>
        </div>
      </div>

      <route-view></route-view>

      <div class="footer">
        <div class="links">
          <!-- <a href="_self">帮助</a>
          <a href="_self">隐私</a>
          <a href="_self">条款</a> -->
        </div>
        <div class="copyright">
          Copyright &copy; 2019 {{copyright}}
          <br>
          <a href="https://beian.miit.gov.cn/" target="_blank" style="margin-right: 10px;">冀ICP备17029854号-1</a>
          <img class="logos" src="https://beian.mps.gov.cn/web/assets/logo01.6189a29f.png" style="width: 16px;">
          <a href="https://beian.mps.gov.cn/#/query/webSearch?code=13019902000276" rel="noreferrer" target="_blank">冀公网安备13019902000276号</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RouteView from './RouteView'
import { mixinDevice } from '@/utils/mixin'

export default {
  name: 'UserLayout',
  components: { RouteView },
  mixins: [mixinDevice],
  computed: {
    copyright(){
      return this.$store.state.brand.copyright
    },
    title(){
      return this.$store.state.brand.title
    },
    logo(){
      return this.$store.state.brand.logo
    },
    describe(){
      return this.$store.state.brand.describe
    }
  },
  data () {
    return {}
  },
  mounted () {
    document.body.classList.add('userLayout')
  },
  beforeDestroy () {
    document.body.classList.remove('userLayout')
  }
}
</script>

<style lang="less" scoped>
  #userLayout.user-layout-wrapper {
    height: 100%;

    &.mobile {
      .container {
        .main {
          max-width: 368px;
          width: 98%;
        }
      }
    }

    .container {
      width: 100%;
      min-height: 100%;
      background: #f0f2f5 url(~@/assets/background.svg) no-repeat 50%;
      background-size: 100%;
      padding: 110px 0 144px;
      position: relative;

      a {
        text-decoration: none;
      }

      .top {
        text-align: center;

        .header {
          height: 44px;
          line-height: 44px;

          .badge {
            position: absolute;
            display: inline-block;
            line-height: 1;
            vertical-align: middle;
            margin-left: -12px;
            margin-top: -10px;
            opacity: 0.8;
          }

          .logo {
            height: 44px;
            vertical-align: top;
            margin-right: 16px;
            border-style: none;
          }

          .title {
            font-size: 33px;
            color: rgba(0, 0, 0, .65);
            font-family: Avenir, 'Helvetica Neue', Arial, Helvetica, sans-serif;
            font-weight: 600;
            position: relative;
            top: 2px;
          }
        }
        .desc {
          font-size: 14px;
          color: rgba(0, 0, 0, 0.45);
          margin-top: 12px;
          margin-bottom: 40px;
        }
      }

      .main {
        min-width: 260px;
        width: 368px;
        margin: 0 auto;
      }

      .footer {
        position: absolute;
        width: 100%;
        bottom: 0;
        padding: 0 16px;
        margin: 48px 0 24px;
        text-align: center;

        .links {
          margin-bottom: 8px;
          font-size: 14px;
          a {
            color: rgba(0, 0, 0, 0.45);
            transition: all 0.3s;
            &:not(:last-child) {
              margin-right: 40px;
            }
          }
        }
        .copyright {
          color: rgba(0, 0, 0, 0.45);
          font-size: 14px;
        }
      }
    }
  }
</style>
